import { Middleware, Context } from '@nuxt/types';

const payAsYouGoGuard: Middleware = (context: Context) => {
  if (!context.store.getters['client/isActivePaidClient']) {
    context.app.router.push({
      path: '/account-management/billing'
    });
  }
};

export default payAsYouGoGuard;
